import React from "react";
import { AiOutlineForm } from 'react-icons/ai';

const RegDig = () => {

    return (
        <div className='pt-10'>
            <div className=" p-6 max-w-2xl mx-auto bg-white rounded-xl shadow-md flex items-center flex-col">            
                <h1 className=' font-bold text-principal text-2xl pb-4 font-sans'>Registros Digitales</h1>

                <p className='text-xl font-sans text-center'>
                    Los registros digitales son un servicio con el que se busca que los usuarios puedan realizar por medio de canales digitales más de 400 trámites, que habitualmente se hacían de forma presencial.
                </p>

                <a
                    href={`https://wa.me/+573104032213?text=Hola,%20quiero%20solicitar%20información%20sobre%20Registros%20Digitales.`} target="_blank" rel="noopener noreferrer"
                    className='text-center bg-principal text-white py-2 px-6 rounded-full border-2 border-principal font-semibold mt-4 hover:bg-white hover:text-principal hover:scale-95 transition-all duration-200 ease-out'>
                    <AiOutlineForm size={25} className='inline-block mr-2' />
                    Solicitar
                </a>

            </div>
        </div>
    );
}

export default RegDig;